<template>
    <v-progress-circular
        class="screen-loading"
        :style="{margin}"
        indeterminate
    ></v-progress-circular>
</template>
<script>
export default {
    name: 'screen-loading',
    props: {
      margin: String
    }
}
</script>
<style lang="scss">
.screen-loading {
  color: var(--brand-color);
  width: 50% !important;
  margin: 10% 25%;
}
</style>



// WEBPACK FOOTER //
// src/components/loaders/ScreenLoading.vue